import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    ProgressIndicatorDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";
import {
    getCornerStyle
} from "../../../../helpers/theme/corner";
import {
    MOTION_CSS_EASINGS
} from "../../../../helpers/motion";
import {
    PROGRESS_INDETERMINATE_RATIO
} from "../../util";
import {
    webStyle
} from "../../../../utils";

const stylesheet = StyleSheet.create({
    webSlideEnd: webStyle({
        animationKeyframes: {
            to: {
                transform: `translateX(-${100 / PROGRESS_INDETERMINATE_RATIO}%)`
            },
            from: {
                transform: "translateX(100%)"
            }
        },
        animationTimingFunction: MOTION_CSS_EASINGS.inOut,
        animationIterationCount: "infinite"
    }),
    webSlideStart: webStyle({
        animationKeyframes: {
            to: {
                transform: `translateX(${100 / PROGRESS_INDETERMINATE_RATIO}%)`
            },
            from: {
                transform: "translateX(-100%)"
            }
        },
        animationTimingFunction: MOTION_CSS_EASINGS.inOut,
        animationIterationCount: "infinite"
    }),
    webFade: webStyle({
        animationTimingFunction: MOTION_CSS_EASINGS.inOut,
        animationIterationCount: "infinite",
        animationKeyframes: {
            "0%, 100%": {
                opacity: 0
            },
            "50%": {
                opacity: 1
            }
        }
    }),
    webSpin: webStyle({
        animationIterationCount: "infinite",
        animationKeyframes: {
            to: {
                transform: "rotate(360deg)"
            },
            from: {
                transform: "rotate(0deg)"
            }
        },
        animationTimingFunction: "linear"
    }),
    layer: {
        ...StyleSheet.absoluteFill
    },
    arc: {
        transform: [
            {
                rotate: "-90deg"
            }
        ]
    },
    slide: {
        flexDirection: "row",
        flex: 1
    },
    steps: {
        flexDirection: "row",
        flex: 1
    },
    segment: {
        overflow: "hidden"
    }
});

export const useStyles = ({
    slideDuration = 0,
    fadeDuration = 0,
    spinDuration = 0,
    currentColors,
    shapeConfigs,
    fraction,
    radiuses,
    spaces
}: ProgressIndicatorDynamicStyleType) => {
    const styles = {
        segment: {
            width: `${PROGRESS_INDETERMINATE_RATIO * 100}%`,
            backgroundColor: currentColors.indicatorColor,
            ...getCornerStyle({
                radius: radiuses.chip,
                shapeConfigs
            })
        } as Mutable<ViewStyle>,
        bar: {
            backgroundColor: currentColors.indicatorColor,
            width: `${fraction * 100}%`,
            ...getCornerStyle({
                radius: radiuses.chip,
                shapeConfigs
            })
        } as Mutable<ViewStyle>,
        fadeLayer: {
            backgroundColor: currentColors.fadeColor
        } as Mutable<ViewStyle>,
        webSlide: webStyle({
            animationDuration: `${slideDuration}ms`
        }) as Mutable<ViewStyle>,
        webSpin: webStyle({
            animationDuration: `${spinDuration}ms`
        }) as Mutable<ViewStyle>,
        webFade: webStyle({
            animationDuration: `${fadeDuration}ms`
        }) as Mutable<ViewStyle>,
        steps: {
            gap: spaces.spacingXs
        } as Mutable<ViewStyle>
    };

    return styles;
};
export default stylesheet;
